<template>
    <DropdownButton>
        <template v-slot:trigger>
            <button class="button" data-toggle="dropdown" :disabled="buttonDisabled">
                <span>{{ translate("admin_create_bracket.coloring") }}</span>
                <span class="icon">
                    <i class="fa fa-angle-down" />
                </span>
            </button>
        </template>
        <template v-slot:content>
            <a class="dropdown-item" v-for="coloring in supportedColorings" :key="coloring" @click="onColoringChoice(coloring)">
                {{ coloring }}
            </a>
            <a class="dropdown-item" @click="onClearColoring">
                {{ translate("common.clear") }}
            </a>
        </template>
    </DropdownButton>
</template>

<script>
    import translatorMixin from "../Common/translatorMixin";
    import DropdownButton from "../Common/DropdownButton.vue";

    export default {
        name: "bracket-color-options",
        components: { DropdownButton },
        mixins: [translatorMixin],
        props: ["buttonDisabled"],
        data() {
            return {
                supportedColorings: ["1/2", "1/4", "1/8"],
            };
        },
        methods: {
            onClearColoring() {
                this.$emit("clearColoring");
            },
            onColoringChoice(coloring) {
                this.$emit("coloringChoice", coloring);
            },
        },
    };
</script>
